// extracted by mini-css-extract-plugin
export default {"icon":"UFBMZJP_HY","button":"jvUkp0opFj","text":"X97X7uhKL2"};